export function safeParse<T = unknown>(str: string): T | null {
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
}
